export class Candidate {
  constructor(id, name, image, email, birthday, education) {
    this.id = id;
    this.name = name;
    this.image = image;
    this.email = email;
    this.birthday = birthday;
    this.education = education;
  }
}
